var map = {
	"./da.json": [
		"df88",
		"lang-da-json"
	],
	"./de.json": [
		"bac1",
		"lang-de-json"
	],
	"./en.json": [
		"e312",
		"lang-en-json"
	],
	"./es.json": [
		"ef52",
		"lang-es-json"
	],
	"./fr.json": [
		"b16e",
		"lang-fr-json"
	],
	"./nl.json": [
		"b94d"
	],
	"./se.json": [
		"be3d",
		"lang-se-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8825";
module.exports = webpackAsyncContext;